import React from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { PhoneNumberInput } from './PhoneNumberInput'

const CustomSelect = styled(Select)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'grey',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'grey',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'grey',
  },
}))

type CreditDebitComponentProps = {
  setPhoneNumber: React.Dispatch<React.SetStateAction<string | undefined>>
  phoneNumberError: () => boolean
  idTypeError: () => boolean
  idList: any[]
  idType?: string
  handleChange: (event: any) => void
  setIdNumber: React.Dispatch<React.SetStateAction<string | undefined>>
  setCountryPhoneCode: React.Dispatch<React.SetStateAction<string | undefined>>
}

export function DuitnowComponent({
  setPhoneNumber,
  phoneNumberError,
  idList,
  idType,
  handleChange,
  setIdNumber,
  idTypeError,
  setCountryPhoneCode,
}: Readonly<CreditDebitComponentProps>) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Box width="100%" mb={1}>
        <Typography variant="h6" fontWeight="bold" color="#4D4D4D">
          Duitnow ID
        </Typography>
      </Box>

      <Box width="100%" mb={3}>
        <Typography variant="body1" color="textSecondary" mb={2}>
          Please enter the ID you used to link with your DuitNow in your banking
          app
        </Typography>
      </Box>

      <Box width="100%" display="flex" flexDirection="column" gap={3}>
        <FormControl fullWidth>
          <InputLabel style={{ color: 'gray' }} id="payment-id-label">
            Payment ID
          </InputLabel>
          <CustomSelect
            labelId="payment-id-label"
            id="payment-id"
            value={idList.find((e) => e.label === idType)?.label ?? ''}
            label="Payment ID"
            onChange={handleChange}>
            {idList.map((id) => (
              <MenuItem key={id.value} value={id.value}>
                {id.label}
              </MenuItem>
            ))}
          </CustomSelect>
        </FormControl>

        {idType && idType !== '5' && (
          <TextField
            label={
              <Typography fontSize={16}>
                {idType === '3' ? 'Passport' : 'IC'}{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            variant="outlined"
            onChange={(e) => setIdNumber(e.target.value)}
            fullWidth
            placeholder="ID Number"
            error={idTypeError()}
            helperText={idTypeError() ? 'Invalid ID' : ''}
          />
        )}

        {idType === '5' && (
          <Box width="100%">
            <PhoneNumberInput
              setCountryPhoneCode={setCountryPhoneCode}
              setPhoneNumber={setPhoneNumber}
            />
            {/* Optional HelperText */}
          </Box>
        )}

        {idType && idType !== '5' && (
          <Box width="100%">
            <PhoneNumberInput
              setCountryPhoneCode={setCountryPhoneCode}
              setPhoneNumber={setPhoneNumber}
            />
            {phoneNumberError() && (
              <Typography variant="caption" color="error">
                Invalid Phone Number
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Box>
  )
}
